(async () => {
const root = document.querySelector('[data-ils-vion-root]');
if (!root || root.dataset.initialized) return;
root.dataset.initialized = 'true';
const amount=Number(root.dataset.offerAmount || 400);
const productName=root.dataset.offerName || 'Vion Gri';
const isVion=root.dataset.productId==='10710770319662';
const offerSlug=({'10710770319662':'vion','10052846092590':'ardews','10052845601070':'loravo','15409120739630':'vayen'})[root.dataset.productId];
if(!offerSlug)return;
const trackingKey=`ils-${offerSlug}-rollout-tracking`;
const attrPrefix=`ils_${offerSlug}_`;
const box = root.querySelector('[data-vion-offer]');
const dialog = root.querySelector('dialog');
const variants = JSON.parse(root.querySelector('[data-vion-variants]').textContent);
const price = root.querySelector('[data-discounted-price]');
function updatePrice(variant) {
  if (!variant || !variants.some(v => v.id === variant.id)) return;
  price.textContent = new Intl.NumberFormat('tr-TR', {style:'currency',currency:'TRY'}).format(Math.max(0, variant.price - amount*100) / 100);
}
document.addEventListener('variant:change', event => updatePrice(event.detail?.variant));
const opener = box.querySelector('[data-open]');
const reopen = box.querySelector('[data-reopen]');
const inlineStatus = box.querySelector('[data-inline-status]');
const button = dialog.querySelector('[data-claim]');
const message = dialog.querySelector('[data-message]');
const details = dialog.querySelector('[data-details]');
const code = dialog.querySelector('[data-code]');
const clocks = root.querySelectorAll('[data-clock]');
const copy = dialog.querySelector('[data-copy]');
const key = root.dataset.offerCampaign || 'ils-vion-rollouts-400-1h-v1';
const legacyKey = 'ils-vion-grey-400-1h-v1';
let legacy = false;
const qaValue = new URLSearchParams(location.hash.slice(1)).get('vion_qa');
const isQA = /^[a-f0-9]{64}$/.test(qaValue || '');
let token;
let current;
let timer;
let busy = false;
let deadline = 0;
const autoOpenAt = performance.now() + 4000;
let autoOpenTimer;
let offerOpened = false;
function openOffer() {
  clearTimeout(autoOpenTimer);
  offerOpened = true;
  if (!dialog.open) { dialog.showModal(); track('open'); }
}
function scheduleOffer() {
  clearTimeout(autoOpenTimer);
  if (offerOpened || legacy || current?.cohort !== 'B' || current.state !== 'ready' || document.hidden) return;
  autoOpenTimer = setTimeout(() => {
    if (!document.hidden && !busy && current?.cohort === 'B' && current.state === 'ready') openOffer();
  }, Math.max(0, autoOpenAt - performance.now()));
}

async function request(path) {
  const response = await fetch(`https://iloveshoes-vion-offer.metin-e91.workers.dev/api/${legacy ? '' : 'rollouts/'}${path}`, {
    method: 'POST', headers: {'Content-Type':'application/json'},
    body: JSON.stringify({token,productId:root.dataset.productId,currency:root.dataset.currency,themeId:root.dataset.themeId}),
    signal: AbortSignal.timeout(35000), cache: 'no-store', credentials: 'omit'
  });
  if (!response.ok) throw new Error('unavailable');
  return response.json();
}
async function attribute(state) {
  if (isQA || !state.visitorId || !['A','B'].includes(state.cohort)) return;
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({attributes:{[attrPrefix+'experiment__']:state.campaign,[attrPrefix+'group__']:state.cohort,[attrPrefix+'visitor__']:state.visitorId,[attrPrefix+'theme__']:root.dataset.themeId,[attrPrefix+'event_ticket__']:state.ticket || ''}}),
    signal:AbortSignal.timeout(8000)
  });
  if(!response.ok) throw new Error('attribution_unavailable');
}

function track(action) {
  if(legacy || !current?.visitorId || !current?.ticket) return;
  const identity={visitorId:current.visitorId,ticket:current.ticket,productId:root.dataset.productId};
  try { localStorage.setItem(trackingKey,JSON.stringify(identity)); } catch { return; }
  const publish=()=>window.Shopify?.analytics?.publish?.('ils_vion_event',{...identity,action});
  if(window.Shopify?.analytics?.publish) publish();
  else { let attempts=0;const retry=setInterval(()=>{if(window.Shopify?.analytics?.publish){clearInterval(retry);publish();}else if(++attempts>=20)clearInterval(retry);},500); }
}

function draw(state) {
  current = state;
  clearInterval(timer);
  scheduleOffer();
  const active = state.state === 'active';
  opener.hidden = ['active', 'expired', 'control'].includes(state.state);
  reopen.hidden = !active;
  details.hidden = !active;
  box.hidden = ['control', 'disabled'].includes(state.state);
  if (state.state === 'disabled') { dialog.close(); return; }
  opener.disabled = false;
  button.disabled = false;
  button.hidden = !['ready', 'pending'].includes(state.state);
  button.textContent = state.state === 'ready' ? `${amount} TL indirimi aktif et` : 'Kodumu tekrar kontrol et';
  opener.querySelector('.offer-trigger-action').textContent = state.state === 'pending' ? 'İndirim kodunu kontrol et ↗' : 'İndirimi aç ↗';
  inlineStatus.textContent = '';
  if (state.state === 'ready') message.textContent = `“${productName}” için sana özel ${amount} TL indirim seni bekliyor. Bu teklif, yalnızca seçilen 300 kişiye özel.\n\nİndirimini aktif ettiğinde 1 saatlik süren başlayacak. Süre dolmadan ürünü sana özel fiyatıyla al.`;
  if (state.state === 'pending') message.textContent = 'Kod henüz doğrulanamadı. Tekrar kontrol edebilirsin; süre yeniden başlamaz.';
  if (state.state === 'expired') {
    inlineStatus.textContent = 'İndirim teklifinin süresi doldu.';
    message.textContent = 'Bu teklifin süresi doldu. Ürünü mevcut fiyatıyla satın alabilirsin.';
  }
  if (active) {
    message.textContent = 'Kodun hazır. Kuponu ödeme sayfasında girebilirsiniz. Süre dolmadan alışverişini tamamla.';
    code.textContent = state.code;
    deadline = performance.now() + Math.max(0, state.expiresAt - state.serverNow);
    const tick = () => {
      const seconds = Math.max(0, Math.ceil((deadline - performance.now()) / 1000));
      if (!seconds) { draw({ ...current, state: 'expired' }); return; }
      for (const clock of clocks) clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    };
    tick();
    if (current.state === 'active') timer = setInterval(tick, 1000);
  }
}

async function claim() {
  if (busy || !token) return;
  busy = true;
  opener.disabled = true;
  button.disabled = true;
  button.hidden = true;
  message.textContent = 'Kodun hazırlanıyor…';
  try { draw(await request('claim', 'POST')); }
  catch {
    message.textContent = 'Kod henüz doğrulanamadı. Tekrar deneyebilirsin.';
    button.textContent = 'Tekrar dene'; button.hidden = false;
    button.disabled = false; opener.disabled = false;
  } finally { busy = false; }
}

opener.addEventListener('click', openOffer);
button.addEventListener('click', claim);
reopen.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
function closeDialog() {
  dialog.close();
  const target = reopen.hidden ? opener : reopen;
  if (!target.hidden) target.focus();
}
dialog.querySelector('[data-close]').addEventListener('click', closeDialog);
dialog.querySelector('[data-continue]').addEventListener('click', closeDialog);
dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
dialog.addEventListener('click', event => {
  const rect = dialog.getBoundingClientRect();
  if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeDialog();
});
copy.addEventListener('click', async () => {
  try { await navigator.clipboard.writeText(code.textContent); copy.textContent = 'Kopyalandı'; }
  catch { copy.textContent = 'Kodu seçip kopyalayabilirsin'; }
});
document.addEventListener('visibilitychange', async () => {
  clearTimeout(autoOpenTimer);
  if (document.hidden || !token || busy) return;
  try { draw(await request('status')); }
  catch {
    clearInterval(timer); details.hidden = true; reopen.hidden = true;
    inlineStatus.textContent = 'Kalan süre doğrulanamadı. Sayfayı yenileyebilirsin.';
    message.textContent = inlineStatus.textContent;
  }
});

try {
  const oldToken=localStorage.getItem(legacyKey);
  if(isVion && !isQA && /^[a-f0-9]{64}$/.test(oldToken||'')) {
    token=oldToken;legacy=true;
    try {const old=await request('status');if(old.state==='active'){draw(old);return;}} catch {}
    legacy=false;
  }
  token = isQA ? qaValue : localStorage.getItem(key);
  if (!/^[a-f0-9]{64}$/.test(token || '')) {
    token = Array.from(crypto.getRandomValues(new Uint8Array(32)), b => b.toString(16).padStart(2,'0')).join('');
    localStorage.setItem(key,token);
  }
  const state = await request('session');
  await attribute(state);
  draw(state);
  if (['A','B'].includes(state.cohort)) track('view');
} catch { box.hidden = true; }

})();
